import { HashRouter,useLocation } from "react-router-dom";
import App from "../App";
import React, { Suspense, lazy } from "react"
import { Route, Routes } from "react-router-dom"

import LoadingRoute from "../components/LoadingRoute";
// import BjhjShopOrder from "../views/BjhjShopOrder";

// 引入页面
const Home = lazy(() => import("../views/Home"))
const SftHome = lazy(() => import("../views/sftHome"))
const SftHomeComplete = lazy(() => import("../views/sftHomeComplete"))
const SftOrderDetails = lazy(() => import("../views/sftOrderDetails"))
//const HjHome = lazy(() => import("../views/hjHome"))
const Layouts = lazy(() => import("../Layouts"))
const Error = lazy(() => import("../views/Error"))
const CheckOrder = lazy(() => import("../views/CheckOrder"))
const ReturnOrder = lazy(() => import("../views/ReturnOrder"))
const OvertimeOrder = lazy(() => import("../views/OvertimeOrder"))
const RejectOrder = lazy(() => import("../views/RejectOrder"))
const WorkingOrder = lazy(() => import("../views/WorkingOrder"))
const FinishOrder = lazy(() => import("../views/FinishOrder"))
const WorkerDetails = lazy(() => import("../views/WorkerDetails"))
const OrderDetails = lazy(() => import("../views/OrderDetails"))
const AcceptedWorker = lazy(() => import("../views/AcceptedWorker"))
const TodayOverTime = lazy(() => import("../views/TodayOvertime"))
const NewCheck = lazy(() => import("../views/NewCheck"))
const ShopOrder = lazy(() => import("../views/ShopOrder"))
const NewOrderDetails = lazy(() => import("../views/NewOrderDetails"))
const BeijingOrder = lazy(() => import("../views/BeijingOrder"))
const BeijingDetails = lazy(() => import("../views/BeijingDetails"))
const OutlineBeijingOrder = lazy(() => import("../views/OutlineBeijingOrder"))
const Kanban = lazy(() => import("../views/Kanban"))
const WaitCompleteOrder = lazy(() => import("../views/WaitCompleteOrder"))
const BjhjOrderDetails = lazy(() => import("../views/BjhjOrderDetails"))
const BjhjOrder = lazy(() => import("../views/BjhjOrder"))
const BjhjWorkerDetails = lazy(() => import("../views/BjhjWorkerDetails"))
const BjhjShopOrder = lazy(() => import("../views/BjhjShopOrder")); // 新增的组件导入
const BjhjDockingOrder = lazy(() => import("../views/BjhjDockingOrder")); // 北京惠居系统对接路由
const UnicomDetails = lazy(() => import("../views/UnicomDetails")); // 联通详情
const CustomerRenewal = lazy(() => import("../views/CustomerRenewal")); // 临期客户
const SmsPost = lazy(() => import("../views/SmsPost")); // 短信营销
const SmsDetail = lazy(() => import("../views/SmsDetail")); // 短信营销
const Pledge = lazy(() => import("../views/Pledge")); // 押金管理
const Address = lazy(() => import("../views/AddressPledge")); // 押金管理
const Order = lazy(() => import("../views/Order"))

const Router = () => {
    // @ts-ignore
    return (
        <HashRouter>
            <Suspense fallback={<div><LoadingRoute /></div>}>
                <Routes>
                    <Route path="" element={<App></App>}></Route>
                    <Route path="/" element={<Layouts />}>
                        <Route path="/home/:n/:s/:t" element={<Home/>}></Route>
                        <Route path="/sfthome/:n/:s/:t" element={<SftHome/>}></Route>
                        <Route path="/sfthomeComplete/:n/:s/:t" element={<SftHomeComplete/>}></Route>
                        <Route path="/sftorder/details" element={<SftOrderDetails/>}></Route>
                       {/* <Route path="/hjhome/:n/:s" element={<HjHome/>}></Route>*/}
                        <Route path="/check/:n/:s" element={<CheckOrder/>}></Route>
                        <Route path="/newcheck/:n/:s" element={<NewCheck/>}></Route>
                        <Route path="/return/:n/:s" element={<ReturnOrder/>}></Route>
                        <Route path="/reject/:n/:s" element={<RejectOrder />}></Route>
                        <Route path="/overtime/:n/:s" element={<OvertimeOrder/>}></Route>
                        <Route path="/working/:n/:s" element={<WorkingOrder/>}></Route>
                        <Route path="/finish/:n/:s" element={<FinishOrder />}></Route>
                        <Route path="/accept/:n/:s" element={<AcceptedWorker />}></Route>
                        <Route path="/work/details" element={<WorkerDetails />}></Route>
                        <Route path="/order/details" element={<OrderDetails />}></Route>
                        <Route path="/today/overtime" element={<TodayOverTime />}></Route>
                        <Route path="/shop/o/:n/:s" element={<ShopOrder />}></Route>
                        <Route path="/new/order/:n/:s" element={<NewOrderDetails />}></Route>
                        <Route path="/beijing/order/:n/:s" element={<BeijingOrder />}></Route>
                        <Route path="/beijing/details" element={<BeijingDetails />}></Route>
                        <Route path="/out/beijing/order/:n/:s" element={<OutlineBeijingOrder />}></Route>
                        <Route path="/kanban" element={<Kanban />}></Route>
                        <Route path="/waitcomplete/:n/:s" element={<WaitCompleteOrder/>}></Route>
                        <Route path="/bjhjshop/o/:n/:s" element={<BjhjShopOrder />}></Route>
                        <Route path="/bjhj/:n/:s/:t" element={<BjhjOrder/>}></Route>
                        <Route path="/bjhjwork/details" element={<BjhjWorkerDetails />}></Route>
                        <Route path="/bjhjorder/details" element={<BjhjOrderDetails />}></Route>
                        <Route path="/bjhj/order/:n/:s" element={<BjhjOrder />} /> {/* 新增的路由 */}
                        <Route path="/bjhj/docking/:n/:s" element={<BjhjDockingOrder />} /> {/* 北京惠居系统对接路由 */}
                        <Route path="/unicom/details" element={<UnicomDetails />}></Route>
						<Route path="/cr/:n/:s" element={<CustomerRenewal />} />
						<Route path="/sms/:n/:s" element={<SmsPost />} />
						<Route path="/sms/detail/:t/:d" element={<SmsDetail />} />
						<Route path="/pledge/:n/:s" element={<Pledge />} />
						<Route path="/address/:n/:s" element={<Address />} />
                        <Route path="/order/:n/:s/:t" element={<Order/>} />  {/* 订单管理*/}
                    </Route>
                    <Route path="*" element={<Error/>}></Route>
                </Routes>
            </Suspense>
        </HashRouter>
    )
}

export default Router;
